import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatCommissionCalendarModel } from 'src/oldApp/model/cat-commission-calendar.model';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatCommissionCalendarService } from 'src/oldApp/services/cat-commission-calendar.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalCommissionCalendarComponent } from 'src/oldApp/shared/modal-commission-calendar/modal-commission-calendar.component';

@Component({
  selector: 'app-cat-commission-calendar',
  templateUrl: './cat-commission-calendar.component.html',
  styleUrls: ['./cat-commission-calendar.component.css']
})
export class CatCommissionCalendarComponent implements OnInit {
  // estado pagina
  public page:string='CatGoalRegion';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public calendars:CatCommissionCalendarModel[]=[];

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[];
  public payGroupCatalog:any[]=[
    {id:0, description:'Grupo 0'},
    {id:1, description:'Grupo 1'},
    {id:2, description:'Grupo 2'},
    {id:3, description:'Grupo 3'},
    {id:4, description:'Grupo 4'},
    {id:5, description:'Grupo 5'}
  ];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private creator:CreatorService,
    private modalService:NgbModal,
    private commissionsCalendarService:CatCommissionCalendarService,
    private employeeJobService:CatEmployeeJobService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  // 
  add=()=> {
    let calendar=this.creator.newCatGoalRegion();
    let modalRef=this.modalService.open(ModalCommissionCalendarComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.calendar={...calendar};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(calendar:CatCommissionCalendarModel)=> {
    let modalRef=this.modalService.open(ModalCommissionCalendarComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.calendar={...calendar};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  jobDescription=calendar=> this.employeeJobCatalog.find(j=> j.employeeJobId===calendar.employeeJobId).description;
  payGroup=calendar=> this.payGroupCatalog.find(g=> g.id===calendar.payGroup).description;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.commissionsCalendarService.getAll(),
      this.employeeJobService.getAll()
    )
    .pipe(
      tap(([calendarResp, jobResp]:[CatCommissionCalendarModel[], CatEmployeeJobModel[]])=> {
        this.calendars=calendarResp;
        this.employeeJobCatalog=jobResp;
        this.viewStatus=1;
      }),
      catchError(error=> {
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer catálogos.'));
      })
    )
    .subscribe();
  }
}
